import * as angular from "angular";
import {ConsolidatedBillingOrdersRequests} from "./services/consolidated-billing-orders-requests.service";
import {BillingOrdersDateRangeContext} from "./services/billing-orders-date-range-context.service";
import {QuickFilterContextService} from "../commons/services/quick-filter-context.service";
import {ViewFilterSettingsService} from "../commons/services/view-filter-settings.service";
import {DateRangeTimeFiltersService} from "../commons/services/date-range-time-filters.service";
import {CommonsService} from "../commons/services/commons-service.service";

angular
  .module('bringoz.admin.billing-accounts')
  .config(billingAccountsConfig);

/* @ngInject */
function billingAccountsConfig($stateProvider) {

  $stateProvider
    .state('billing-accounts', {
      parent: 'bringoz.site',
      url: '/billing-accounts',
      abstract: true,
      template: '<billing-accounts></billing-accounts>'
    })

    // Accounts
    .state('billing-accounts.accounts', {
      url: '',
      template: '<billing-accounts-view></billing-accounts-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, site) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Billing Accounts'});
        triBreadcrumbsService.addCrumb({name: 'Billing'});
        triBreadcrumbsService.addCrumb({name: 'Finance'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});
      }
    })

    // Orders
    .state('billing-accounts.orders', {
      url: '/billing-orders?:from&:to&:accountIds&:packagesIds&:billingAccountIds&:billingOrderStatus&:invoiceStatuses&:tagNames&:isConsolidated&:hasPrice&:dateRangeTemplateType',
      template: '<billing-orders-view from="vm.from" to="vm.to" account-ids="vm.accountIds" packages-ids="vm.packagesIds" ' +
        'billing-account-ids="vm.billingAccountIds" billing-order-status="vm.billingOrderStatus" invoice-statuses="vm.invoiceStatuses" tag-names="vm.tagNames" is-consolidated="vm.isConsolidated" ' +
        'has-price="vm.hasPrice" selected-quick-filter-id="vm.selectedQuickFilterId" date-range-template-type="vm.dateRangeTemplateType"></billing-orders-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, $stateParams, commonsService: CommonsService, dateRangeTimeFiltersService: DateRangeTimeFiltersService,
                            billingOrdersDateRangeContext: BillingOrdersDateRangeContext, viewFilterSettingsService: ViewFilterSettingsService, $state, quickFilterContextService: QuickFilterContextService) {

        const quickActiveFilter = viewFilterSettingsService.getActiveQuickFilter($state.current.name);

        this.dateRangeTemplateType = $stateParams.dateRangeTemplateType || quickActiveFilter?.settings.dateRangeTemplateType || viewFilterSettingsService.getDateRangeTemplateType();
        this.from;
        this.to;
        if (this.dateRangeTemplateType) {
          const dateRangeFilter = dateRangeTimeFiltersService.getDateRangeFilterByType(this.dateRangeTemplateType);
          this.from = dateRangeFilter.dateStart;
          this.to = dateRangeFilter.dateEnd;
        } else if ($stateParams.from && $stateParams.to) {
          this.from = parseInt($stateParams.from)
          this.to = parseInt($stateParams.to);
        }


        this.selectedQuickFilterId = quickActiveFilter?.id;
        this.accountIds = commonsService.parseArrayStateParam($stateParams.accountIds) || quickActiveFilter?.settings.accountIds || viewFilterSettingsService.getAccountIds() || [];
        this.packagesIds = commonsService.parseArrayStateParam($stateParams.packagesIds) || quickActiveFilter?.settings.packagesIds || viewFilterSettingsService.getPackagesIds() || [];
        this.billingAccountIds = commonsService.parseArrayStateParam($stateParams.billingAccountIds) || quickActiveFilter?.settings.billingAccountIds || viewFilterSettingsService.getBillingAccountIds() || [];
        this.billingOrderStatus = $stateParams.billingOrderStatus || quickActiveFilter?.settings.billingOrderStatus || viewFilterSettingsService.getBillingOrderStatus() || undefined;
        this.invoiceStatuses = commonsService.parseArrayStateParam($stateParams.invoiceStatuses) || quickActiveFilter?.settings.invoiceStatuses || viewFilterSettingsService.getBillingOrderInvoiceStatuses() || [];
        this.tagNames = commonsService.parseArrayStateParam($stateParams.tagNames) || quickActiveFilter?.settings.tagNames || viewFilterSettingsService.getTags() || [];
        this.isConsolidated = typeof $stateParams.isConsolidated === "boolean" ? JSON.parse($stateParams.isConsolidated) : (typeof quickActiveFilter?.settings.isConsolidated === "boolean" ? quickActiveFilter?.settings.isConsolidated : viewFilterSettingsService.getIsConsolidated());
        this.hasPrice = typeof $stateParams.hasPrice === "boolean" ? JSON.parse($stateParams.hasPrice) : (typeof quickActiveFilter?.settings.hasPrice === "boolean" ? quickActiveFilter?.settings.hasPrice : viewFilterSettingsService.getHasPrice());

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Billing Orders'});
        triBreadcrumbsService.addCrumb({name: 'Billing'});
        triBreadcrumbsService.addCrumb({name: 'Finance'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});
      }
    })

    // Consolidated Billing Orders

    // .state('billing-accounts.orders', {
    //   url: '/billing-orders?:from&:to&:accountIds&:packagesIds&:billingAccountIds&:billingOrderStatus&:invoiceStatuses&:tagNames&:isConsolidated&:hasPrice&:dateRangeTemplateType',
    //   template: '<billing-orders-view from="vm.from" to="vm.to" account-ids="vm.accountIds" packages-ids="vm.packagesIds" ' +
    //     'billing-account-ids="vm.billingAccountIds" billing-order-status="vm.billingOrderStatus" invoice-statuses="vm.invoiceStatuses" tag-names="vm.tagNames" is-consolidated="vm.isConsolidated" ' +
    //     'has-price="vm.hasPrice" selected-quick-filter-id="vm.selectedQuickFilterId" date-range-template-type="vm.dateRangeTemplateType"></billing-orders-view>',
    //   controllerAs: 'vm',
    //   controller: function (triBreadcrumbsService, $stateParams, commonsService: CommonsService, dateRangeTimeFiltersService: DateRangeTimeFiltersService,
    //                         billingOrdersDateRangeContext: BillingOrdersDateRangeContext, viewFilterSettingsService: ViewFilterSettingsService, $state, quickFilterContextService: QuickFilterContextService) {

    // template: '<consolidated-billing-orders-view from="vm.from" to="vm.to" billing-account-ids="vm.billingAccountIds" ' +
    // 'status="vm.status" has-price="vm.hasPrice" selected-consolidated-order="vm.consolidatedBillingOrder"></consolidated-billing-orders-view>',


    .state('billing-accounts.consolidated-orders', {
      url: '/consolidated-billing-orders?:from&:to&:consolidatedId&:billingAccountIds&:status&:filterDateType&:hasPrice&:hasInvoiceError',
      template: '<consolidated-billing-orders-view from="vm.from" to="vm.to" billing-account-ids="vm.billingAccountIds" ' +
        'status="vm.status" filter-date-type="vm.filterDateType" has-price="vm.hasPrice" selected-consolidated-order="vm.consolidatedBillingOrder" date-range-template-type="vm.dateRangeTemplateType"' +
        ' has-invoice-error="vm.hasInvoiceError"></consolidated-billing-orders-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, $stateParams, commonsService: CommonsService, $state, consolidatedBillingOrder, billingOrdersDateRangeContext, quickFilterContextService: QuickFilterContextService, viewFilterSettingsService: ViewFilterSettingsService, dateRangeTimeFiltersService: DateRangeTimeFiltersService) {

        const quickActiveFilter = viewFilterSettingsService.getActiveQuickFilter($state.current.name);

        this.dateRangeTemplateType = $stateParams.dateRangeTemplateType || quickActiveFilter?.settings.dateRangeTemplateType || viewFilterSettingsService.getDateRangeTemplateType();
        this.from;
        this.to;
        if (this.dateRangeTemplateType) {
          const dateRangeFilter = dateRangeTimeFiltersService.getDateRangeFilterByType(this.dateRangeTemplateType);
          this.from = dateRangeFilter.dateStart;
          this.to = dateRangeFilter.dateEnd;
        } else if ($stateParams.from && $stateParams.to) {
          this.from = parseInt($stateParams.from)
          this.to = parseInt($stateParams.to);
        }
        this.billingAccountIds = $stateParams.billingAccountIds || commonsService.parseArrayStateParam($stateParams.billingAccountId) || quickActiveFilter?.settings.billingAccountIds || viewFilterSettingsService.getBillingAccountIds() || [];
        this.consolidatedBillingOrder = consolidatedBillingOrder;
        this.status = $stateParams.status;
        this.filterDateType = $stateParams.filterDateType;
        this.hasPrice = typeof $stateParams.hasPrice === "boolean" ? JSON.parse($stateParams.hasPrice) : (typeof viewFilterSettingsService.getHasPrice() === "boolean" ? viewFilterSettingsService.getHasPrice() : true);
        this.hasInvoiceError = $stateParams.hasInvoiceError ? JSON.parse($stateParams.hasInvoiceError) : undefined;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Consolidated Billing Orders'});
        triBreadcrumbsService.addCrumb({name: 'Billing'});
        triBreadcrumbsService.addCrumb({name: 'Finance'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});
      },
      resolve: {
        consolidatedBillingOrder: function (consolidatedBillingOrdersRequests: ConsolidatedBillingOrdersRequests, $stateParams, $q, site) {
          return $stateParams.consolidatedId ?
            consolidatedBillingOrdersRequests.getOne($stateParams.consolidatedId) :
            $q.when();
        }
      }
    })

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // Billing Account
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    //Billing Account - Abstract
    .state('billing-account', {
      parent: 'bringoz.site',
      url: '/billing-accounts/:billingAccountId',
      abstract: true,
      controllerAs: 'vm',
      template: '<billing-account billing-account="vm.billingAccount"></billing-account>',
      controller: function (billingAccount, site) {
        this.billingAccount = billingAccount;
      },
      resolve: {
        billingAccount: function ($billingAccounts, $stateParams, site) {
          return $billingAccounts($stateParams.billingAccountId).$asyncValue();
        }
      }
    })

    //Billing Account - Billing Orders
    .state('billing-account.orders', {
      url: '/billing-orders?:from&:to&:accountIds&:packagesIds&:billingOrderStatus&:invoiceStatuses&:tagNames&:isConsolidated&:hasPrice&:dateRangeTemplateType&:billingAccountId',
      template: '<billing-orders-view  billing-account-id="vm.billingAccountId" billing-account-ids="vm.billingAccountIds" preferences="vm.preferences" ' +
        'from="vm.from" to="vm.to" account-ids="vm.accountIds" packages-ids="vm.packagesIds" billing-order-status="vm.billingOrderStatus" invoice-statuses="vm.invoiceStatuses" tag-names="vm.tagNames" ' +
        'has-price="vm.hasPrice" is-consolidated="vm.isConsolidated" selected-quick-filter-id="vm.selectedQuickFilterId" date-range-template-type="vm.dateRangeTemplateType"></billing-orders-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, $stateParams, billingAccount, quickFilterContextService: QuickFilterContextService,
                            preferences, commonsService: CommonsService, viewFilterSettingsService: ViewFilterSettingsService, $state, dateRangeTimeFiltersService: DateRangeTimeFiltersService) {

        const quickActiveFilter = viewFilterSettingsService.getActiveQuickFilter($state.current.name);

        this.dateRangeTemplateType = $stateParams.dateRangeTemplateType || quickActiveFilter?.settings.dateRangeTemplateType || viewFilterSettingsService.getDateRangeTemplateType();
        this.from;
        this.to;

        if (this.dateRangeTemplateType) {
          const dateRangeFilter = dateRangeTimeFiltersService.getDateRangeFilterByType(this.dateRangeTemplateType);
          this.from = dateRangeFilter.dateStart;
          this.to = dateRangeFilter.dateEnd;
        } else if ($stateParams.from && $stateParams.to) {
          this.from = parseInt($stateParams.from)
          this.to = parseInt($stateParams.to);
        }

        this.selectedQuickFilterId = quickActiveFilter?.id;
        this.packagesIds = commonsService.parseArrayStateParam($stateParams.packagesIds) || quickActiveFilter?.settings.packagesIds || viewFilterSettingsService.getPackagesIds() || [];
        this.billingAccountId = $stateParams.billingAccountId;
        this.billingOrderStatus = $stateParams.billingOrderStatus || quickActiveFilter?.settings.billingOrderStatus || viewFilterSettingsService.getBillingOrderStatus() || undefined;
        this.invoiceStatuses = commonsService.parseArrayStateParam($stateParams.invoiceStatuses) || quickActiveFilter?.settings.invoiceStatuses || viewFilterSettingsService.getBillingOrderInvoiceStatuses() || [];
        this.tagNames = commonsService.parseArrayStateParam($stateParams.tagNames) || quickActiveFilter?.settings.tagNames || viewFilterSettingsService.getTags() || [];
        this.isConsolidated = typeof $stateParams.isConsolidated === "boolean" ? JSON.parse($stateParams.isConsolidated) : (typeof quickActiveFilter?.settings.isConsolidated === "boolean" ? quickActiveFilter?.settings.isConsolidated : viewFilterSettingsService.getIsConsolidated());
        this.hasPrice = typeof $stateParams.hasPrice === "boolean" ? JSON.parse($stateParams.hasPrice) : (typeof quickActiveFilter?.settings.hasPrice === "boolean" ? quickActiveFilter?.settings.hasPrice : viewFilterSettingsService.getHasPrice());
        this.preferences = preferences;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Billing Orders'});
        triBreadcrumbsService.addCrumb({name: billingAccount.accountingName, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Billing Accounts', state: 'billing-accounts.accounts'});
        triBreadcrumbsService.addCrumb({name: 'Billing'});
        triBreadcrumbsService.addCrumb({name: 'Finance'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});
      },
      resolve: {
        preferences: function (billingAccountsRequests, $stateParams, site) {
          return billingAccountsRequests.getPreferences($stateParams.billingAccountId);
        }
      }
    })

    // Billing Account - Consolidated Billing Orders
    .state('billing-account.consolidated-orders', {
      url: '/consolidated-billing-orders?:from&:to&:consolidatedId&:billingAccountIds&:status&:filterDateType&:hasPrice&:hasInvoiceError',
      template: '<consolidated-billing-orders-view from="vm.from" to="vm.to" billing-account-id="vm.billingAccountId" ' +
        'status="vm.status" filter-date-type="vm.filterDateType" has-price="vm.hasPrice" selected-consolidated-order="vm.consolidatedBillingOrder" has-invoice-error="vm.hasInvoiceError"></consolidated-billing-orders-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, $stateParams, billingAccount, commonsService: CommonsService, consolidatedBillingOrder, viewFilterSettingsService: ViewFilterSettingsService) {
        this.from = $stateParams.from ? parseInt($stateParams.from) : undefined;
        this.to = $stateParams.to ? parseInt($stateParams.to) : undefined;
        this.billingAccountId = $stateParams.billingAccountId;
        this.consolidatedBillingOrder = consolidatedBillingOrder;
        this.status = $stateParams.statuses;
        this.filterDateType = $stateParams.filterDateType;
        this.hasPrice = typeof $stateParams.hasPrice === "boolean" ? JSON.parse($stateParams.hasPrice) : (typeof viewFilterSettingsService.getHasPrice() === "boolean" ? viewFilterSettingsService.getHasPrice() : true);
        this.hasInvoiceError = $stateParams.hasInvoiceError ? JSON.parse($stateParams.hasInvoiceError) : undefined;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Consolidated Billing Orders'});
        triBreadcrumbsService.addCrumb({name: billingAccount.accountingName, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Billing Accounts', state: 'billing-accounts.accounts'});
        triBreadcrumbsService.addCrumb({name: 'Billing'});
        triBreadcrumbsService.addCrumb({name: 'Finance'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});
      },
      resolve: {
        consolidatedBillingOrder: function (consolidatedBillingOrdersRequests: ConsolidatedBillingOrdersRequests, $stateParams, $q, site) {
          return $stateParams.consolidatedId ?
            consolidatedBillingOrdersRequests.getOne($stateParams.consolidatedId) :
            $q.when();
        }
      }
    })

    //Billing Account - Preferences
    .state('billing-account.preferences', {
      url: '/preferences',
      template: '<billing-account-preferences preferences="vm.preferences" billing-account="$ctrl.billingAccount" on-change="$ctrl.onBillingAccountChange(billingAccount)"></billing-account-preferences>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, preferences, billingAccount) {
        this.preferences = preferences;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Preferences'});
        triBreadcrumbsService.addCrumb({name: billingAccount.accountingName, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Billing Accounts', state: 'billing-accounts.accounts'});
        triBreadcrumbsService.addCrumb({name: 'Billing'});
        triBreadcrumbsService.addCrumb({name: 'Finance'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});
      },
      resolve: {
        preferences: function (billingAccountsRequests, $stateParams, site) {
          return billingAccountsRequests.getPreferences($stateParams.billingAccountId);
        }
      }
    })
}

